import axios from "axios";
import Logger from "js-logger";
import { useFormStore } from "@/businesslogic/stores/formStore";

const backendLoggingHandler = (messages: any[], context: any) => {
  if (context.level === Logger.WARN || context.level === Logger.ERROR) {
    const piniaStore = useFormStore();
    axios
      .post(process.env.VUE_APP_BACKEND_URL + "/api/log", {
        severity: context.level.name,
        data: messages,
        sessionId: piniaStore.state?.sessionId,
      })
      .catch((e) => {
        console.warn("Fehler beim Sender der Log-Nachricht.", e);
      });
  }
};

const consoleHandler = Logger.createDefaultHandler({
  formatter: function (messages, context) {
    messages.unshift(new Date().toUTCString() + " - " + context.level.name + ":");
  },
});

const initLogging = (): void => {
  switch (process.env.VUE_APP_LOG_LEVEL) {
    case "trace":
      Logger.setLevel(Logger.TRACE);
      break;
    case "debug":
      Logger.setLevel(Logger.DEBUG);
      break;
    case "info":
      Logger.setLevel(Logger.INFO);
      break;
    case "warn":
      Logger.setLevel(Logger.WARN);
      break;
    default:
      Logger.setLevel(Logger.ERROR);
      break;
  }

  Logger.setHandler(function (messages, context) {
    consoleHandler(messages, context);
    backendLoggingHandler(messages, context);
  });
};

export default initLogging;
